import { render, staticRenderFns } from "./RiskCase.vue?vue&type=template&id=84a5fad0&scoped=true"
import script from "./RiskCase.vue?vue&type=script&lang=js"
export * from "./RiskCase.vue?vue&type=script&lang=js"
import style0 from "./RiskCase.vue?vue&type=style&index=0&id=84a5fad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a5fad0",
  null
  
)

export default component.exports